import { SECTION_KEY_GETTERS } from './accountImportConstants';

export const buildSections = (formatCurrency) => [
    {
        key: 'profiles',
        title: 'Profil',
        count: 0,
        getKey: SECTION_KEY_GETTERS.profiles,
        singleSelect: true,
        columns: [
            { label: 'Firma', render: (item) => item.companyName || '-' },
            { label: 'E-Mail', render: (item) => item.email || '-' },
            { label: 'Telefon', render: (item) => item.phone || '-' },
            { label: 'Adresse', render: (item) => item.street || '-' },
            { label: 'Ort', render: (item) => [item.zip, item.city].filter(Boolean).join(' ') || '-' },
            { label: 'Land', render: (item) => item.country || '-' },
        ],
    },
    {
        key: 'customers',
        title: 'Kunden',
        count: 0,
        getKey: SECTION_KEY_GETTERS.customers,
        columns: [
            { label: 'Name', render: (item) => item.displayName || '-' },
            { label: 'Firma', render: (item) => item.companyName || '-' },
            { label: 'E-Mail', render: (item) => item.email || '-' },
            { label: 'Adresse', render: (item) => item.street || '-' },
            { label: 'Ort', render: (item) => [item.zip, item.city].filter(Boolean).join(' ') || '-' },
            { label: 'Land', render: (item) => item.country || '-' },
            { label: 'Geloescht', render: (item) => (item.deleted ? 'Ja' : 'Nein'), align: 'right' },
        ],
    },
    {
        key: 'suppliers',
        title: 'Lieferanten',
        count: 0,
        getKey: SECTION_KEY_GETTERS.suppliers,
        columns: [
            { label: 'Name', render: (item) => item.displayName || '-' },
            { label: 'Firma', render: (item) => item.companyName || '-' },
            { label: 'E-Mail', render: (item) => item.email || '-' },
            { label: 'Adresse', render: (item) => item.street || '-' },
            { label: 'Ort', render: (item) => [item.zip, item.city].filter(Boolean).join(' ') || '-' },
            { label: 'Land', render: (item) => item.country || '-' },
            { label: 'Geloescht', render: (item) => (item.deleted ? 'Ja' : 'Nein'), align: 'right' },
        ],
    },
    {
        key: 'articles',
        title: 'Artikel',
        count: 0,
        getKey: SECTION_KEY_GETTERS.articles,
        columns: [
            { label: 'Nummer', render: (item) => item.articleNumber || '-' },
            { label: 'Name', render: (item) => item.name || '-' },
            { label: 'Preis', render: (item) => formatCurrency(item.price), align: 'right' },
            { label: 'Steuer', render: (item) => (item.taxRate != null ? `${item.taxRate}%` : '-'), align: 'right' },
            { label: 'Geloescht', render: (item) => (item.deleted ? 'Ja' : 'Nein'), align: 'right' },
        ],
    },
    {
        key: 'shippingCosts',
        title: 'Versandkosten',
        count: 0,
        getKey: SECTION_KEY_GETTERS.shippingCosts,
        columns: [
            { label: 'Beschreibung', render: (item) => item.name || '-' },
            { label: 'Betrag', render: (item) => formatCurrency(item.amount), align: 'right' },
            { label: 'Steuer', render: (item) => (item.taxRate != null ? `${item.taxRate}%` : '-'), align: 'right' },
            { label: 'Geloescht', render: (item) => (item.deleted ? 'Ja' : 'Nein'), align: 'right' },
        ],
    },
    {
        key: 'invoices',
        title: 'Rechnungen',
        count: 0,
        getKey: SECTION_KEY_GETTERS.invoices,
        groupByYear: true,
        getYear: (item) => item.invoiceDate,
        columns: [
            { label: 'Nummer', render: (item) => item.invoiceNumber || '-' },
            { label: 'Datum', render: (item) => item.invoiceDate || '-' },
            { label: 'Kunde', render: (item) => item.customerName || '-' },
            { label: 'Betrag', render: (item) => formatCurrency(item.grossAmount), align: 'right' },
            { label: 'Bezahlt', render: (item) => (item.paid ? 'Ja' : 'Nein'), align: 'right' },
            { label: 'Geloescht', render: (item) => (item.deleted ? 'Ja' : 'Nein'), align: 'right' },
        ],
    },
    {
        key: 'bookings',
        title: 'Buchungen',
        count: 0,
        getKey: SECTION_KEY_GETTERS.bookings,
        groupByYear: true,
        getYear: (item) => item.date,
        columns: [
            { label: 'Typ', render: (item) => item.relation || '-' },
            { label: 'Datum', render: (item) => item.date || '-' },
            { label: 'Beschreibung', render: (item) => item.description || '-' },
            { label: 'Kategorie', render: (item) => item.category || '-' },
            { label: 'Bezug', render: (item) => item.targetName || '-' },
            { label: 'Betrag', render: (item) => formatCurrency(item.amount), align: 'right' },
        ],
    },
];
